import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const searchIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M48.724 27.103c0-11.941-9.68-21.622-21.621-21.622S5.481 15.161 5.481 27.103s9.68 21.621 21.622 21.621a21.54 21.54 0 0 0 15.288-6.333 21.54 21.54 0 0 0 6.333-15.288m14.424 32.169c2.584 2.584-1.292 6.46-3.876 3.876l-15.04-15.04a27 27 0 0 1-17.13 6.098C12.135 54.206 0 42.07 0 27.103 0 12.134 12.134 0 27.103 0 42.07 0 54.206 12.134 54.206 27.103c0 6.346-2.194 12.35-6.098 17.13z"/></svg>`
);
